/* Reviews carousel: tap a review card OR the 'Read all reviews' button to scroll to Judge.me reviews. */
(function(){
  var STYLE_ID = 'esp-reviews-button-style';
  function injectStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.esp-read-all-reviews{display:inline-flex;align-items:center;gap:8px;margin:14px auto 4px;padding:10px 18px;background:#fff;border:1.5px solid #16a34a;color:#16a34a;border-radius:999px;font-size:13px;font-weight:700;text-decoration:none;cursor:pointer;transition:.2s}'+
      '.esp-read-all-reviews:hover{background:#16a34a;color:#fff}'+
      '.esp-read-all-reviews svg{width:13px;height:13px}'+
      '.esp-read-all-wrap{display:flex;justify-content:center;width:100%}';
    document.head.appendChild(s);
  }

  function findReviewSlides(){
    var keywords = ['Jason Miller','Oliver Thompson','Emily Carter'];
    var slides = document.querySelectorAll('.splide__slide');
    var hits = [];
    for (var i=0;i<slides.length;i++){
      var t = slides[i].textContent || '';
      for (var j=0;j<keywords.length;j++){
        if (t.indexOf(keywords[j]) >= 0){ hits.push(slides[i]); break; }
      }
    }
    return hits;
  }

  function findJudgeMe(){
    return document.getElementById('judgeme_product_reviews')
        || document.querySelector('.jdgm-widget')
        || document.querySelector('.jdgm-rev-widg')
        || document.querySelector('[id*="judgeme"]')
        || document.querySelector('[class*="judgeme"]');
  }

  function scrollToReviews(){
    var target = findJudgeMe();
    if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
  }

  function bindCard(slide){
    if (slide.dataset.espReviewBound === '1') return;
    slide.dataset.espReviewBound = '1';
    slide.style.cursor = 'pointer';
    var startX=0, startY=0, moved=false;
    slide.addEventListener('pointerdown', function(e){ startX=e.clientX; startY=e.clientY; moved=false; });
    slide.addEventListener('pointermove', function(e){
      if (Math.abs(e.clientX-startX)>10 || Math.abs(e.clientY-startY)>10) moved = true;
    });
    slide.addEventListener('pointerup', function(e){
      if (moved) return;
      if (e.target.closest('.splide__arrow')) return;
      if (e.target.closest('a, button, input, select, textarea')) return;
      scrollToReviews();
    });
  }

  function injectButton(splideRoot){
    if (!splideRoot || splideRoot.dataset.espBtnInjected === '1') return;
    splideRoot.dataset.espBtnInjected = '1';
    var wrap = document.createElement('div');
    wrap.className = 'esp-read-all-wrap';
    var a = document.createElement('a');
    a.className = 'esp-read-all-reviews';
    a.href = '#judgeme_product_reviews';
    a.innerHTML = 'Read all reviews <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    a.addEventListener('click', function(e){
      e.preventDefault();
      scrollToReviews();
    });
    wrap.appendChild(a);
    splideRoot.parentNode.insertBefore(wrap, splideRoot.nextSibling);
  }

  function init(){
    injectStyle();
    var slides = findReviewSlides();
    slides.forEach(bindCard);
    if (slides.length > 0){
      var splideRoot = slides[0].closest('.splide');
      injectButton(splideRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);
  setTimeout(init, 2500);
})();
